export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/icomoon.8c42e1e3.ttf";